import { render, staticRenderFns } from "./ExperienceDetails.vue?vue&type=template&id=1b047a44&scoped=true&"
import script from "./ExperienceDetails.vue?vue&type=script&lang=js&"
export * from "./ExperienceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceDetails.vue?vue&type=style&index=0&id=1b047a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b047a44",
  null
  
)

export default component.exports